export default __webpack_public_path__ + "static/media/yellowLightning.211ecabb.svg";